import { render } from "./BaseComponent.vue?vue&type=template&id=13009bd5"
import script from "./BaseComponent.vue?vue&type=script&scoped=true&lang=js"
export * from "./BaseComponent.vue?vue&type=script&scoped=true&lang=js"

import "./BaseComponent.vue?vue&type=style&index=0&id=13009bd5&lang=css"

import exportComponent from "/var/www/xserenedestiny/DuangdeeLiveAdmin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__